import UserStateInformation from "./UserStateInformation";
import { UserStateInformationModalStyled } from "./styled/UserStateInformationModalStyled";
import ModalsCloseButton from "../Modals/components/ModalsCloseButton/ModalsCloseButton";

function UserStateInformationModal() {
    return <>
        <UserStateInformationModalStyled>
            <UserStateInformation/>
            <ModalsCloseButton/>
        </UserStateInformationModalStyled>
    </>;
}

export default UserStateInformationModal;
